var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":_vm.toggleHamburger}},[_c('span'),_c('span'),_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }